var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-6"},[_c('user-form',{attrs:{"data":_vm.data,"loading":_vm.isLoading,"disabled":_vm.disabled},on:{"onSubmit":_vm.onSubmit,"onCancel":_vm.onCancel,"onEditable":_vm.onEditable,"onRemove":_vm.onConfirmRemove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }